"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetricsUtils = void 0;
const constants_1 = require("gather-http-common/dist/src/public/metrics/constants");
const utils_1 = require("gather-common/dist/src/public/utils");
const luxon_1 = require("luxon");
const amplitudeOperationsProcessors_1 = require("./amplitudeOperationsProcessors");
const stringHelpers_1 = require("gather-common/dist/src/public/stringHelpers");
const getMetricsUtils = (dataSource) => {
    const logMetricsEvent = async (eventName, eventProperties = {}, eventGroups, category, label, value) => {
        const date = luxon_1.DateTime.fromMillis(Date.now()).setLocale("en");
        eventProperties = {
            platform: dataSource.getPlatform(),
            dayOfWeek: date.weekdayLong,
            hourOfDay: date.hour,
            ...eventProperties,
            ...(eventProperties.spaceId ? { spaceId: (0, utils_1.roomURLIdToDBId)(eventProperties.spaceId) } : {}),
        };
        await setAndGetAmplitudeDeviceId();
        if (eventGroups) {
            dataSource.logEvent({
                event_type: eventName,
                event_properties: eventProperties,
                groups: eventGroups,
            });
        }
        else {
            dataSource.logEvent({
                event_type: eventName,
                event_properties: eventProperties,
            });
        }
        dataSource.runOnNextIdleCb(async () => {
            if (category) {
                dataSource.gtagEvent(eventName, category, label, value);
            }
        });
    };
    async function amplitudeIdentify(operation, userProperty, value) {
        await setAndGetAmplitudeDeviceId();
        const processor = amplitudeOperationsProcessors_1.amplitudeIdentifyOperationProcessors[operation] ?? amplitudeOperationsProcessors_1.defaultAmplitudeOperationProcessor;
        if (processor) {
            if (processor.isValidValue(value)) {
                dataSource.identify(operation, userProperty, processor.processValue(value));
            }
            else {
                console.error(`metrics/utils failed: amplitudeIdentify for ${operation}`);
            }
        }
    }
    function amplitudeGroupIdentify(operation, groupType, groupValue, groupProperty, groupPropertyValue) {
        const processor = amplitudeOperationsProcessors_1.amplitudeIdentifyGroupOperationProcessors[operation] ?? amplitudeOperationsProcessors_1.defaultAmplitudeOperationProcessor;
        if (processor) {
            if (processor.isValidValue(groupPropertyValue)) {
                dataSource.groupIdentify(operation, groupType, groupValue, groupProperty, processor.processValue(groupPropertyValue));
            }
            else {
                console.error(`metrics/utils failed: amplitudeGroupIdentify for ${operation}`);
            }
        }
    }
    const amplitudeSetGroup = async (groupType, groupValue) => {
        await setAndGetAmplitudeDeviceId();
        dataSource.setGroup(groupType, groupValue);
    };
    const setUserInfo = (email) => {
        amplitudeIdentify(constants_1.AmplitudeIdentifyOperations.SET, constants_1.MetricsUserProperties.EMAIL, email);
        amplitudeIdentify(constants_1.AmplitudeIdentifyOperations.SET, constants_1.MetricsUserProperties.IS_EMPLOYEE, email.endsWith("@gather.town"));
        const [_, emailDomain] = (0, stringHelpers_1.getEmailParts)(email);
        if (emailDomain) {
            amplitudeSetGroup(constants_1.MetricsGroupTypes.ORG_ID, emailDomain);
        }
    };
    const logSignInEvent = async (user, isNewUser, method, eventProperties) => {
        if (user?.uid) {
            await dataSource.setUserId(user.uid);
        }
        else {
            console.error("Could not invoke setUserId");
        }
        const userInfo = {
            userId: user?.uid,
            email: user?.email,
            isNewUser,
            method,
        };
        if (isNewUser) {
            setUserInfo(user?.email || "");
        }
        logMetricsEvent(constants_1.MetricsEventName.SIGN_IN, { ...userInfo, ...eventProperties }, undefined, constants_1.MetricsEventCategory.AUTHENTICATION, method);
    };
    const updateRevenueUserProperty = (revenueType, amount) => {
        amplitudeIdentify(constants_1.AmplitudeIdentifyOperations.ADD, revenueType, amount);
    };
    const setAndGetAmplitudeDeviceId = async () => {
        const deviceIdFromDataSource = await dataSource.getDefaultDeviceId();
        if (deviceIdFromDataSource) {
            await dataSource.setDeviceId(deviceIdFromDataSource);
            return deviceIdFromDataSource;
        }
        else {
            const deviceIdFromAmplitude = dataSource.getDeviceId();
            if (deviceIdFromAmplitude) {
                await dataSource.setDeviceId(deviceIdFromAmplitude);
                dataSource.onDeviceId(deviceIdFromAmplitude);
            }
            return deviceIdFromAmplitude;
        }
    };
    return {
        amplitudeIdentify,
        amplitudeGroupIdentify,
        updateRevenueUserProperty,
        logMetricsEvent,
        logSignInEvent,
        setUserInfo,
    };
};
exports.getMetricsUtils = getMetricsUtils;
//# sourceMappingURL=utils.js.map